import { createStore } from "vuex";

export default createStore({
  state: {
    logged: undefined,
    user: undefined,
    token: undefined,
    apiLoading: 0,
  },
  mutations: {
    login(state, data) {
      state.logged = true;
      state.token = data.token;
      state.user = data.user;
    },
    requestStarted(state) {
      state.apiLoading += 1;
    },
    requestFinished(state) {
      state.apiLoading = Math.max(0, state.apiLoading - 1);
    },
  },
  actions: {},
  modules: {},
});
